<mat-dialog-content>
	<div id="interactive" class="viewport">
		<video playsinline autoplay muted></video>
	</div>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-button color="primary" (click)="dialogRef.close(barcode)">CLOSE</button>
</mat-dialog-actions>
